import { makeAutoObservable } from 'mobx'
import { uiStore } from 'shared/store/uiStore'
import { logger } from 'shared/lib'
import { ComplianceApi } from 'entities/Compliance'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { SettingsPath } from 'pages/settings/route/settingsPath'
import type { TollFreeStepsStore } from 'pages/settings/pages/compliance/pages/tollFree/store/tollFreeStepsStore'

export class ForbiddenMessageStore {
  constructor(private _tollFreeStepsStore: TollFreeStepsStore, private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  get tollFreeStepsStore() {
    return this._tollFreeStepsStore
  }

  private _forbiddenMessageAgreed = false

  get forbiddenMessageAgreed() {
    return this._forbiddenMessageAgreed
  }

  get isNextStepDisabled() {
    return !this._forbiddenMessageAgreed
  }

  setForbiddenMessageAgreed = () => {
    this._forbiddenMessageAgreed = !this._forbiddenMessageAgreed
  }

  onSubmit = async () => {
    const {
      profileId,
      useCaseDetailsStore: { rejectedNumberId, rejectedProfileId },
    } = this.tollFreeStepsStore

    if (!profileId) return

    try {
      this.tollFreeStepsStore.setStepLoading(true)

      const isResubmit = rejectedNumberId && rejectedProfileId

      const { data } = isResubmit
        ? await ComplianceApi.resubmitTollFree({
            profile_id: rejectedProfileId,
            number_id: rejectedNumberId,
          })
        : await ComplianceApi.submitTollFree(profileId)

      if (data) {
        await this._entities.complianceStore.fetchOrganizationTollFree()
        await this._entities.complianceStore.loadAndUpdateUnverifiedTollFreeNumbers()

        uiStore.changeRoute({
          path: `/${SettingsPath.compliance.tollFree.root}`,
        })

        this.tollFreeStepsStore.useCaseDetailsStore.setActiveNumber(null)
      }
    } catch (e) {
      logger.error(e)
    } finally {
      this.tollFreeStepsStore.setStepLoading(false)
    }
  }
}
